import * as actionTypes from "../actions/actionTypes";

import {
	getAllList,
	updateList,
  pageIncreament,
  clearAll,
  createList,
  setLoader,
} from "../utility/todoListFunctions";

const initialState = {
  timelineTodoList: [],
  total: "",
  isLoading: true,
  page: 1,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ALL_LIST:
      return getAllList(state, action.timelineTodoList, action.total);

    case actionTypes.UPDATE_LIST:
      return updateList(state, action.list);

    case actionTypes.SET_LIST_LOADER:
      return setLoader(state, action.loaderValue);

    case actionTypes.CREATE_LIST:
      return createList(state, action.list);

    case actionTypes.LIST_PAGE_INCREAMENT:
      return pageIncreament(state);

    case actionTypes.CLEAR_ALL_LIST:
      return clearAll(state);

    default:
      return state;
  }
};

export default reducer;
